import { Component } from '@angular/core';

@Component({
  selector: 'app-sales-order-poll-configuration',
  templateUrl: './sales-order-poll-configuration.component.html',
  styleUrls: ['./sales-order-poll-configuration.component.css'],
})
export class SalesOrderPollConfigurationComponent {}
